var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._t("footer-menu",null,{"activeID":_vm.activeID,"toggleDropdown":_vm.toggleDropdown})],2)}
var staticRenderFns = []

export { render, staticRenderFns }